// extracted by mini-css-extract-plugin
export default {"container":"so-z","ratingLayout":"to-z","ratingLabel":"uo-z","nonInteractiveRatingLabel":"vo-z"};